import styled, { css } from 'styled-components';
import { MHighlightIconAlignment } from './MHighlightIcon.types';

const spacers = {
  spacers: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
  },
};

type StyledProps = {
  alignment: MHighlightIconAlignment;
};

const stylesByAlignment = ({ alignment }: StyledProps) =>
  alignment === MHighlightIconAlignment.Centered
    ? css`
        align-items: center;
        text-align: center;
      `
    : css`
        align-items: flex-start;
        text-align: left;
      `;

export const Wrapper = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  row-gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  ${stylesByAlignment}
`;
